<template>
    <div
        ref="googleBtn"
        :class="$style.google_signin"
    />
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { onMounted, ref, watch } from 'vue'

import { useGoogleAuth } from '@/store/google-auth-store'

interface GoogleAuthProps {
    onFinish?: () => void
}
const props = defineProps<GoogleAuthProps>()

const googleAuthStore = useGoogleAuth()
const { initialized } = storeToRefs(googleAuthStore)

const googleBtn = ref<HTMLElement | null>(null)

const initSignIn = () => {
    if (!window.google || !googleBtn.value) {
        return
    }

    window.google.accounts.id.renderButton(googleBtn.value, {
        type: 'standard',
        text: 'signin_with',
        theme: 'outline',
        shape: 'pill',
        size: 'large',
        logo_alignment: 'left',
        // @ts-ignore https://developers.google.com/identity/gsi/web/reference/js-reference#state
        state: JSON.stringify({ returnURL: window.location.href }),
        // @ts-ignore https://developers.google.com/identity/gsi/web/reference/js-reference#click_listener
        click_listener: onClickHandler,
    })
}

function onClickHandler() {
    googleAuthStore.onFinishSignIn(props.onFinish)
}

watch(initialized, initSignIn)
onMounted(() => {
    if (initialized.value) {
        initSignIn()
    }
})
</script>
<style module>
.google_signin {
    color-scheme: light;
    height: 44px;
    overflow: hidden;
}
</style>
